function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var OverviewTemplate = require('./overview.template');
var AdminNetworkUI = require('./network');
var AdminOverviewUI = /*#__PURE__*/function () {
  function AdminOverviewUI(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.admin-overview';
    _classCallCheck(this, AdminOverviewUI);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.balance = '—';
    this.balance_loading = false;
    this.saving = false;
    this.network_ui = new AdminNetworkUI(app, mod);
  }
  return _createClass(AdminOverviewUI, [{
    key: "render",
    value: function render() {
      this.refresh();
      this.loadBalance();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.app.browser.replaceElementContentBySelector(OverviewTemplate(this.app, this.mod, {
        balance: this.balance_loading && this.balance === '—' ? '…' : this.balance
      }), this.container);
      this.attachEvents();
      this.network_ui.render();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var copy = document.getElementById('admin-copy-server-key');
      if (copy) copy.onclick = function () {
        return _this.copyServerKey(copy);
      };
      var home = document.getElementById('admin-server-home');
      if (home) {
        home.onchange = function () {
          return _this.saveHome(home.value);
        };
      }
    }
  }, {
    key: "copyServerKey",
    value: function () {
      var _copyServerKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(button) {
        var key, status, focused, usedSelection, copied, _navigator$clipboard, textarea, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              key = this.mod.server_publickey;
              if (!(!key || button.disabled)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              status = document.querySelector("".concat(this.container, " .admin-key-copy-status"));
              focused = document.activeElement;
              usedSelection = false;
              button.disabled = true;
              copied = false;
              _context.p = 2;
              if (!((_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText)) {
                _context.n = 6;
                break;
              }
              _context.p = 3;
              _context.n = 4;
              return navigator.clipboard.writeText(key);
            case 4:
              copied = true;
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
            case 6:
              if (!copied) {
                usedSelection = true;
                textarea = document.createElement('textarea');
                textarea.value = key;
                textarea.readOnly = true;
                textarea.style.position = 'fixed';
                textarea.style.left = '-9999px';
                document.body.append(textarea);
                try {
                  textarea.select();
                  copied = document.execCommand('copy');
                } finally {
                  textarea.remove();
                }
              }
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t2 = _context.v;
              copied = false;
            case 8:
              _context.p = 8;
              button.disabled = false;
              if (usedSelection) focused === null || focused === void 0 || focused.focus();
              button.querySelector('i').className = copied ? 'fa-solid fa-check' : 'fa-solid fa-copy';
              if (status) status.textContent = copied ? 'Public key copied.' : 'Copy failed. Select the public key and copy it manually.';
              return _context.f(8);
            case 9:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5], [2, 7, 8, 9]]);
      }));
      function copyServerKey(_x) {
        return _copyServerKey.apply(this, arguments);
      }
      return copyServerKey;
    }()
  }, {
    key: "saveHome",
    value: function () {
      var _saveHome = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(defaultModule) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(!defaultModule || this.saving)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return this.saveOptions({
                defaultModule: defaultModule
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function saveHome(_x2) {
        return _saveHome.apply(this, arguments);
      }
      return saveHome;
    }()
  }, {
    key: "saveOptions",
    value: function () {
      var _saveOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data) {
        var _this2 = this;
        var tx, ok, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.saving = true;
              _context3.p = 1;
              _context3.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.server_publickey);
            case 2:
              tx = _context3.v;
              tx.msg = {
                module: 'Admin',
                request: 'update-options',
                data: data
              };
              _context3.n = 3;
              return tx.sign();
            case 3:
              ok = false;
              _context3.n = 4;
              return this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                var res = typeof res_tx.returnMessage === 'function' ? res_tx.returnMessage() : res_tx;
                if (res !== null && res !== void 0 && res.err) {
                  if (typeof siteMessage === 'function') {
                    siteMessage(res.err, 5000);
                  }
                  return;
                }
                _this2.mod.server_info = _this2.mod.server_info || {};
                _this2.mod.server_info.options = _objectSpread(_objectSpread({}, _this2.mod.server_info.options), data);
                ok = true;
                if (typeof siteMessage === 'function') {
                  siteMessage('Server settings saved.', 3000);
                }
              }, this.mod.server_publickey);
            case 4:
              return _context3.a(2, ok);
            case 5:
              _context3.p = 5;
              _t3 = _context3.v;
              if (typeof siteMessage === 'function') {
                siteMessage(_t3.message || String(_t3), 5000);
              }
              return _context3.a(2, false);
            case 6:
              _context3.p = 6;
              this.saving = false;
              return _context3.f(6);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 5, 6, 7]]);
      }));
      function saveOptions(_x3) {
        return _saveOptions.apply(this, arguments);
      }
      return saveOptions;
    }()
  }, {
    key: "loadBalance",
    value: function () {
      var _loadBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var key, response, text, total, _iterator, _step, line, cols, _t4, _t5;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              key = this.mod.server_publickey;
              if (!(!key || this.balance_loading)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.balance_loading = true;
              this.updateBalanceDisplay('…');
              _context4.p = 2;
              _context4.n = 3;
              return fetch("/balance/".concat(encodeURIComponent(key)));
            case 3:
              response = _context4.v;
              if (response.ok) {
                _context4.n = 4;
                break;
              }
              throw new Error('unavailable');
            case 4:
              _context4.n = 5;
              return response.text();
            case 5:
              text = _context4.v;
              total = 0n;
              _iterator = _createForOfIteratorHelper(text.trim().split('\n'));
              _context4.p = 6;
              _iterator.s();
            case 7:
              if ((_step = _iterator.n()).done) {
                _context4.n = 10;
                break;
              }
              line = _step.value;
              cols = line.split(' ');
              if (!(cols.length < 5)) {
                _context4.n = 8;
                break;
              }
              return _context4.a(3, 9);
            case 8:
              try {
                total += BigInt(cols[4]);
              } catch (err) {
                // skip malformed rows
              }
            case 9:
              _context4.n = 7;
              break;
            case 10:
              _context4.n = 12;
              break;
            case 11:
              _context4.p = 11;
              _t4 = _context4.v;
              _iterator.e(_t4);
            case 12:
              _context4.p = 12;
              _iterator.f();
              return _context4.f(12);
            case 13:
              this.balance = "".concat(this.app.wallet.convertNolanToSaito(total), " SAITO");
              _context4.n = 15;
              break;
            case 14:
              _context4.p = 14;
              _t5 = _context4.v;
              this.balance = '—';
            case 15:
              _context4.p = 15;
              this.balance_loading = false;
              this.updateBalanceDisplay(this.balance);
              return _context4.f(15);
            case 16:
              return _context4.a(2);
          }
        }, _callee4, this, [[6, 11, 12, 13], [2, 14, 15, 16]]);
      }));
      function loadBalance() {
        return _loadBalance.apply(this, arguments);
      }
      return loadBalance;
    }()
  }, {
    key: "updateBalanceDisplay",
    value: function updateBalanceDisplay(text) {
      var el = document.querySelector("".concat(this.container, " .admin-server-balance"));
      if (el) {
        el.textContent = text;
      }
    }
  }]);
}();
module.exports = AdminOverviewUI;